export default __webpack_public_path__ + "static/media/bg-pattern-intro.bf6b3e1b.svg";